import React, { Component } from "react";
import axios, { CancelToken } from "axios";
import { Translate, I18n } from "react-redux-i18n";
import { setAlert } from "../../../actions/alertActions";
import { connect } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import PageSelector from "../../utils/components/pageSelector/PageSelector";
import EditModelUsers from "../manageAccount/modals/EditModelUsers";
import "../../../styles/components/account/manageAccount/ManageUsers.scss";
import "../../../styles/utils/_loadingScreen.scss";
import ConfirmationModal from "./editUser/ConfirmationModal";
import CreateB2B from "../../chargers/modals/CreateB2B";
import CreateB2C from "../../chargers/modals/CreateB2C";

import back from "../../../styles/images/arrow_black.svg";
// import { relativeTimeRounding } from "moment";

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      selectedOption: "email",
      selectedOptionUserType: "email",
      textInputValue: "",
      pageNumber: 1,
      resultsLimit: 10,
      totalPages: 0,
      totalEntries: 0,
      sortBy: "",
      sortDirection: "asc",
      processedData: [],
      data: [],
      isEditing: false,
      userStates: {},
      isSelectedUser: null,
      showConfirmationModal: false,
      selectedUser: null,
      showModalB2B: false,
      showModalB2C: false,
    };
    this.handleOnChangeResultsLimit =
      this.handleOnChangeResultsLimit.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleTextInputChange = this.handleTextInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.fetchContracts = this.fetchContracts.bind(this);
    this.removeFilters = this.removeFilters.bind(this);
    this.handleOnPageSwitch = this.handleOnPageSwitch.bind(this);
    this.handleBlockClick = this.handleBlockClick.bind(this);
    this.handleResetPasswordClick = this.handleResetPasswordClick.bind(this);
    this.filterAfterCreation = this.filterAfterCreation.bind(this);
    this.closeModalCreateB2B = this.closeModalCreateB2B.bind(this);
    this.handleButtonCreateB2B = this.handleButtonCreateB2B.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      this.forceUpdate();
    }
  }

  handleOptionChange = (event) => {
    this.setState({
      selectedOption: event.target.value,
      selectedOptionUserType: "",
      textInputValue: "",
    });
  };
  handleTextInputChange = (event) => {
    if (event.target.value === "b2b" || event.target.value === "b2c") {
      this.setState({ selectedOptionUserType: event.target.value });
    }
    this.setState({ textInputValue: event.target.value });
  };

  handleButtonClick = () => {
    if (
      this.state.selectedOption === "clientType" &&
      this.state.selectedOptionUserType === ""
    ) {
      this.setState({ textInputValue: "b2b" }, () => {
        // This callback is called after setState is done
        this.fetchContracts();
      });
    } else {
      if (this.state.textInputValue !== 0) {
        this.setState({ pageNumber: 1 }, () => {
          // This callback is called after setState is done
          this.fetchContracts();
        });
      } else {
        this.fetchContracts();
      }
    }
  };

  filterAfterCreation = (params) => {
    this.safeSetState(
      (prevState) => ({
        selectedOption: "name",
        textInputValue: params.name,
      }),
      () => {
        // Callback function to be executed after setState is finished
        this.fetchContracts();
      }
    );
  };

  componentDidMount() {
    this._mounted = true;
    this.fetchContracts();
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  handleButtonCreateB2B = () => {
    this.setState({ showModalB2B: true });
  };

  closeModalCreateB2B = () => {
    this.setState({ showModalB2B: false });
  };

  handleButtonCreateB2C = () => {
    this.setState({ showModalB2C: true });
  };

  closeModalCreateB2C = () => {
    this.setState({ showModalB2C: false });
  };

  handleSort = (columnName) => {
    const { sortBy, sortDirection, data } = this.state;

    if (sortBy === columnName) {
      this.setState({
        sortDirection: sortDirection === "asc" ? "desc" : "asc",
      });
    } else {
      this.setState({ sortBy: columnName, sortDirection: "asc" });
    }
  };

  handleOnChangeResultsLimit(e) {
    const resultsLimit = e.target.value;

    this.safeSetState(
      (prevState) => ({
        resultsLimit: resultsLimit,
        pageNumber: 1,
      }),
      () => {
        // Callback function to be executed after setState is finished
        this.fetchContracts();
      }
    );
  }

  handleOnPageSwitch(_e, direction) {
    let updatedPageNumber;

    if (direction === "right") {
      updatedPageNumber = this.state.pageNumber + 1;
    } else if (direction === "left") {
      updatedPageNumber = this.state.pageNumber - 1;
    } else if (direction === "first") {
      updatedPageNumber = 1;
    } else if (direction === "last") {
      updatedPageNumber = this.state.totalPages;
    } else {
      // Handle other directions if needed
      updatedPageNumber = direction;
    }

    this.safeSetState({ pageNumber: updatedPageNumber }, () => {
      // Callback function to be executed after setState is finished
      this.fetchContracts();
    });
  }

  removeFilters() {
    this.safeSetState(
      (prevState) => ({
        textInputValue: "",
      }),
      () => {
        // Callback function to be executed after setState is finished
        this.fetchContracts();
      }
    );
  }

  fetchContracts() {
    let params = {
      pageNumber: this.state.pageNumber,
      limitQuery: this.state.resultsLimit,
    };

    if (this.state.textInputValue.length > 0) {
      params = {
        field: this.state.selectedOption,
        value: this.state.textInputValue,
        pageNumber: this.state.pageNumber,
        limitQuery: this.state.resultsLimit,
      };
    }

    axios
      .get("/api/private/users/byClientName", {
        params,
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        let filteredData = response.data.filter(
          (obj) => obj.email !== this.props.email
        );
        this.setState({
          data: filteredData,
          totalPages: response.headers.numberofpages,
        });
      })
      .catch((err) => {
        if (err.response) {
          this.props.setAlert(I18n.t(err?.response?.data?.code), "danger");
        } else if (err.request) {
          console.log(err.request);
        } else {
          console.log("Error", err.message);
        }
      });
  }

  handleBlockClick(user) {
    const { userStates } = this.state;

    if (!user.blocked) {
      const patch = {
        reason: "FLEET_MANAGER",
      };
      axios
        .patch(`/api/private/users/contracts/deactivate/${user._id}`, patch)
        .then((res) => {
          if (res.status === 204) {
            this.props.setAlert(I18n.t("manageUsers_blockMessage"), "primary");
            this.setState({
              userStates: {
                ...userStates,
                [user._id]: true,
              },
            });
            this.fetchContracts();
          }
        })
        .catch((err) =>
          this.props.setAlert(
            I18n.t(err?.response?.data?.code || "general_errorMessage"),
            "danger"
          )
        );
    } else {
      axios
        .patch(`/api/private/users/contracts/activate/${user._id}`)
        .then((res) => {
          if (res.status === 204) {
            this.props.setAlert(I18n.t("manageUsers_unlockMessage"), "primary");
            this.setState({
              userStates: {
                ...userStates,
                [user._id]: false,
              },
            });
            this.fetchContracts();
          }
        })
        .catch((err) =>
          this.props.setAlert(
            I18n.t(err?.response?.data?.code || "general_errorMessage"),
            "danger"
          )
        );
    }
  }

  toggleConfirmationModal = () => {
    this.setState((prevState) => ({
      showConfirmationModal: !prevState.showConfirmationModal,
    }));
  };

  handleResetPasswordClick() {
    axios
      .post(`/api/private/users/resetPassword/${this.state.selectedUser._id}`)
      .then((res) => {
        if (res.status === 200) {
          this.toggleConfirmationModal();
          this.props.setAlert(I18n.t("email_resetPassword_title"), "primary");
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const { sortBy, sortDirection, data, selectedOption, textInputValue } =
      this.state;
    const sortedData = [...data].sort((a, b) => {
      const valueA = a[this.state.sortBy];
      const valueB = b[this.state.sortBy];

      if (typeof valueA === "string" && typeof valueB === "string") {
        const comparison = valueA.localeCompare(valueB);
        return sortDirection === "asc" ? comparison : -comparison;
      } else {
        return sortDirection === "asc" ? valueA - valueB : valueB - valueA;
      }
    });

    const { createB2CUsers, createB2BUsers } = this.props.userPackage;
    const allowFilterUserType = createB2CUsers && createB2BUsers;
    return (
      <>
        {this.state.data ? (
          <>
            <div
              id="manageUsers"
              className="main-component main-container"
              style={{
                overflow: "visible",
                height: "54rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <p>
                    <b>
                      <Translate value="manageUsers_users" />
                    </b>
                  </p>
                </div>
                {/* OPTIONS ON TOP OF THE SCREEN {DROPDOWN TO SELECT TABLE COLUMN, TEXTINPUT/DROPDOWN, APPLY FILTERS, REMOVE FILTERS} */}
                <div className="fcrow">
                  <div className="pfc">
                    <select
                      value={selectedOption}
                      onChange={this.handleOptionChange}
                      className="customSelect"
                    >
                      <option value="name">{I18n.t("manageUsers_name")}</option>
                      <option value="email">
                        {I18n.t("manageUsers_email")}
                      </option>
                      <option value="mobile">
                        {I18n.t("manageUsers_mobile")}
                      </option>
                      {allowFilterUserType === true && (
                        <option value="clientType">
                          {I18n.t("manageUsers_userType")}
                        </option>
                      )}
                    </select>
                  </div>
                  <div className="hfc">
                    {this.state.selectedOption !== "clientType" ? (
                      <input
                        type="text"
                        value={textInputValue}
                        onChange={this.handleTextInputChange}
                        style={{
                          borderRadius: "10px",
                          padding: "5px",
                          border: "1px solid #ccc",
                          marginRight: "5px",
                          height: "100%",
                          fontSize: 10,
                        }}
                      />
                    ) : (
                      <select
                        value={this.state.selectedOptionUserType}
                        onChange={this.handleTextInputChange}
                        className="customselectb2b"
                      >
                        <option value="b2b">
                          <Translate value="manageUsers_b2b" />
                        </option>
                        <option value="b2c">
                          <Translate value="manageUsers_b2c" />
                        </option>
                      </select>
                    )}

                    <button
                      onClick={this.handleButtonClick}
                      className="filterButtons"
                      style={{
                        backgroundColor: this.props.brand.colors.primaryColor,
                      }}
                    >
                      <Translate value="manageUsers_applyFilters" />
                    </button>
                    <button
                      onClick={this.removeFilters}
                      className="filterButtons"
                      style={{
                        backgroundColor: this.props.brand.colors.primaryColor,
                      }}
                    >
                      <Translate value="manageUsers_removeFilters" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="component-container">
                <div className="table-container">
                  <div className="table-header">
                    <div className="row no-gutters">
                      <div
                        className="col-12 row no-gutters titles"
                        style={{ width: "100%", height: "2rem" }}
                      >
                        <div
                          className="col title"
                          onClick={() => this.handleSort("name")}
                          style={{
                            maxWidth: "25rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_name")}
                        >
                          <Translate value="manageUsers_name" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("email")}
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_email")}
                        >
                          <Translate value="manageUsers_email" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("internationalPrefix")}
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_prefix")}
                        >
                          <Translate value="manageUsers_prefix" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("mobile")}
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_mobile")}
                        >
                          <Translate value="manageUsers_mobile" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("username")}
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_username")}
                        >
                          <Translate value="manageUsers_username" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("clientType")}
                          style={{
                            maxWidth: "10rem",
                            minWidth: "10rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_userType")}
                        >
                          <Translate value="manageUsers_userType" />
                        </div>
                        <div
                          className="col title"
                          onClick={() => this.handleSort("blocked")}
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          title={I18n.t("manageUsers_state")}
                        >
                          <Translate value="manageUsers_state" />
                        </div>
                        <div
                          className="col title"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "flex-end",
                            textAlign: "center",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="table-values">
                    {sortedData.map((user, index) => (
                      <div
                        key={index}
                        className="col-12 row no-gutters values slim"
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "white" : "#66A9BA",
                          display: "flex",
                          justifyContent: "center",
                          alignSelf: "center",
                        }}
                      >
                        <div
                          className="col"
                          style={{
                            maxWidth: "25rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                          title={user.name}
                        >
                          {user.name}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            whiteSpace: "nowrap",

                            textAlign: "center",
                          }}
                          title={user.email}
                        >
                          {user.email}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            textAlign: "center",
                          }}
                          title={user.internationalPrefix}
                        >
                          {user.internationalPrefix}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            textAlign: "center",
                          }}
                          title={user.mobile}
                        >
                          {user.mobile}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                          title={user.username}
                        >
                          {user.username}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "10rem",
                            minWidth: "10rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                          title={
                            user.clientType === "b2b" ? (
                              <Translate value="manageUsers_b2b" />
                            ) : (
                              <Translate value="manageUsers_b2c" />
                            )
                          }
                        >
                          {user.clientType === "b2b" ? (
                            <Translate value="manageUsers_b2b" />
                          ) : (
                            <Translate value="manageUsers_b2c" />
                          )}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            alignSelf: "center",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                          title={
                            user.blocked
                              ? I18n.t("manageUsers_active")
                              : I18n.t("manageUsers_blocked")
                          }
                        >
                          {!user.blocked
                            ? I18n.t("manageUsers_active")
                            : I18n.t("manageUsers_blocked")}
                        </div>
                        <div
                          className="col"
                          style={{
                            maxWidth: "15rem",
                            minWidth: "5rem",
                            alignSelf: "center",
                          }}
                        >
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="custom-dropdown-toggle"
                            >
                              ...
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu-right">
                              <Dropdown.Item
                                onClick={() =>
                                  this.setState({
                                    isEditing: true,
                                    selectedUser: user,
                                  })
                                }
                              >
                                {I18n.t("manageUsers_editUser")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  this.setState({
                                    showConfirmationModal: true,
                                    selectedUser: user,
                                  })
                                }
                              >
                                {I18n.t("manageUsers_resetPassword")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => this.handleBlockClick(user)}
                              >
                                {this.state.userStates[user._id] !== undefined
                                  ? this.state.userStates[user._id]
                                    ? I18n.t("manageUsers_unlock")
                                    : I18n.t("manageUsers_block")
                                  : !user.blocked
                                  ? I18n.t("manageUsers_block")
                                  : I18n.t("manageUsers_unlock")}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {this.state.showConfirmationModal && (
                <ConfirmationModal
                  show={this.state.showConfirmationModal}
                  onHide={() =>
                    this.setState({
                      showConfirmationModal: false,
                    })
                  }
                  onConfirm={() => this.handleResetPasswordClick()}
                  onCancel={() =>
                    this.setState({
                      showConfirmationModal: false,
                    })
                  }
                  title="Confirmation"
                  message={I18n.t("manageUsers_newPassword")}
                  cancelButtonText={I18n.t("general_no")}
                  confirmButtonText={I18n.t("general_yes")}
                />
              )}
              {this.state.isEditing && (
                <EditModelUsers
                  user={this.state.selectedUser}
                  show={this.state.isEditing}
                  onHide={() => this.setState({ isEditing: false })}
                  fetchContracts={this.fetchContracts}
                />
              )}
              <div style={{ display: "flex", justifyContent: "center" }}>
                {createB2BUsers && (
                  <button
                    onClick={this.handleButtonCreateB2B}
                    className="createButtonsEvio"
                    style={{
                      backgroundColor: this.props.brand.colors.primaryColor,
                    }}
                  >
                    {I18n.t("addUserWeb")}
                  </button>
                )}
                {createB2CUsers && (
                  <button
                    onClick={this.handleButtonCreateB2C}
                    className="createButtonsEvio"
                    style={{
                      backgroundColor: this.props.brand.colors.primaryColor,
                    }}
                  >
                    {I18n.t("addUserApp")}
                  </button>
                )}
              </div>
              <CreateB2B
                show={this.state.showModalB2B}
                onHide={() => this.closeModalCreateB2B()}
                onSubmit={this.handleButtonClick}
                callSuccess={() =>
                  this.props.setAlert(I18n.t("success_modalB2B/B2C"), "primary")
                }
                callFailure={(err) => {
                  console.log(err);
                  this.props.setAlert(err, "danger");
                }}
                filterCreatedUser={(params) => this.filterAfterCreation(params)}
              />

              <CreateB2C
                show={this.state.showModalB2C}
                onHide={() => this.closeModalCreateB2C()}
                onSubmit={this.handleButtonClick}
                callSuccess={() =>
                  this.props.setAlert(I18n.t("success_modalB2B/B2C"), "primary")
                }
                callFailure={(err) => this.props.setAlert(err, "danger")}
                filterCreatedUser={(params) => this.filterAfterCreation(params)}
              />
              <div className="main-container-footer">
                <div className="select-container">
                  <label>
                    <Translate value="history_resultsLimit" />
                  </label>
                  <select
                    name="resultsLimit"
                    value={this.state.resultsLimit}
                    onChange={this.handleOnChangeResultsLimit}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </select>
                </div>

                <PageSelector
                  totalPages={this.state.totalPages}
                  selected={this.state.pageNumber}
                  onPageSwitch={this.handleOnPageSwitch}
                />
              </div>
            </div>
          </>
        ) : (
          <div>{I18n.t("manageUsers_loading")}</div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  isCompany: state.account.isCompany,
  wasAdmin: state.account.wasAdmin,
  userPackage: state.account.accountData.userPackage,
  email: state.account.accountData.email,
  i18n: state.i18n,
});

export default connect(mapStateToProps, {
  setAlert,
})(ManageUsers);
